import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import {
  selectLoading,
  selectError,
  selectErrorInfo,
  selectStatus,
  getPaymentInfoAsync,
} from '../../features/payment/payment-slice';
import { useParams, Navigate } from 'react-router-dom';
import { Paths } from '../../config/routes';
import { Status } from '../../constants';
import styles from './styles.module.scss';
import Loading from 'components/common/loading';
import MessageStatus from 'components/message-status';

const Auth = () => {
  const { token } = useParams();

  const loading = useAppSelector(selectLoading);
  const error = useAppSelector(selectError);
  const errorInfo = useAppSelector(selectErrorInfo);
  const status = useAppSelector(selectStatus);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (token) dispatch(getPaymentInfoAsync(token));
  }, []);

  return (
    <div className={styles.auth_container}>
      {loading && <Loading fullScreem noBackground />}
      {!loading && error && <MessageStatus errorInfo={errorInfo} />}
      {!loading && !error && status === Status.SUCCESS && <Navigate to={Paths.CHECKOUT} />}
    </div>
  );
};

export default Auth;
